import { Outlet } from "react-router-dom"

export default function CareersLayout() {
  return (
    <div className="container careers-layout" dir="rtl">
      <h2>مدارس </h2>
      {/* <p>لوريم ايبسوم دولار سيت أميت ,كونسيكتيتور أدايبا يسكينج أليايت,سيت دو أيوسمود تيمبور

أنكايديديونتيوت لابوري ات دولار ماجنا أليكيوا . يوت انيم أد مينيم فينايم,كيواس نوستريد?</p> */}
      
      <Outlet />
    </div>
  )
}
